import { Directive, HostBinding, HostListener, inject, Input } from '@angular/core';

import { A11yBooleanInput, A11yInteractive, A11yRole } from '../interfaces/a11y.interfaces';
import { A11yKeyboardService } from '../services/a11y-keyboard.service';
import { toBoolean } from '../utils/a11y.util';

@Directive({
  selector: '[khA11yMenuItem]'
})
export class A11yMenuItemDirective implements A11yInteractive, A11yRole {
  private readonly keyboardService = inject(A11yKeyboardService);

  @Input() public disabled: A11yBooleanInput = false;

  @HostBinding('attr.role') public readonly role = 'menuitem';

  @HostBinding('attr.tabindex')
  public get tabindex(): string {
    return this.disabledState ? '-1' : '0';
  }

  @HostBinding('attr.aria-disabled')
  public get ariaDisabled(): string | null {
    return this.disabledState ? 'true' : null;
  }

  @HostListener('keydown', ['$event'])
  public onA11yKeydown(event: KeyboardEvent): void {
    if (this.disabledState) {
      return;
    }

    this.keyboardService.activateOnEnterOrSpace(event, () => {
      (event.currentTarget as HTMLElement).click();
    });
  }

  private get disabledState(): boolean {
    return toBoolean(this.disabled, true);
  }
}
